<script>
/**
 * Type : Page
 * 실험실 화면
 * 실험적이거나 베타 테스트가 필요한 기능들을 선행해보는 실험실 페이지
 * 
 */

// import { test as base } from 'playwright/test';

import Title from "@/components/admin/common/TitleArea.vue"


export default {
  name: "Admin-parcel-infomation",
  meta: {
    title: "어드민-실험실"
  },
  components: {
    Title,
  },
  
  data() {
    return {
      description   : {
        title : '실험실'
      },
      
      files: [],
      session     : this.$store.getters.getLocalSession,
    }
  },
  methods: {
    /**
     * Title        : 오늘 날짜 출발 콘솔 상태 변경
     * Status       : Actived
     * Description  : 오늘 날짜 출발 콘솔 상태를 변경한다.
     */
    async updateConsolStatus (type = 'depart') {

      let payload = {
        type  : type
      }

      let config = {
        method  : "POST",
        url     : "/api/consol/updateConsolStatus",
        data    : payload,
        name    : "[ Axios / 오늘 날짜 출발 콘솔 상태 변경 ]"
      }

      await this.$http(config)
        .then((res) => {
          this.$emit("load-list")

          this.$q.notify({
            type    : 'positive',
            message : '상태를 변경했습니다.'
          })

          this.$log.info(res)
        })
        .catch((err) => {
          this.$log.debug(err)
          alert('상태변경에 실패했습니다')
      })
    },
  },


  mounted() {

    this.$log.log("[ Lab ] mounted")
  
  },
}
</script>


<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title
          :desc="description">
        </Title>
      </div>
    </div>

    <div class="row q-mt-lg">
      <div class="col">
        <div class="comp-box">
          <div class="row">
            <div class="col">
              <h5>운송편 상태 변경 테스트 - 인천 기준</h5>
            </div>
          </div>
          <q-btn
            label="최근 운송편 상태 조회 테스트(출발)"
            color="primary"
            @click="() => { updateConsolStatus('depart') }" />

          <q-btn
            label="최근 운송편 상태 조회 테스트(도착)"
            color="secondary"
            @click="() => { updateConsolStatus('arrival') }" />
        </div>
      </div>
    </div>

  </q-page>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
